import {
  Actions,
  GamesActionsTypes,
  GetFavouriteGamesSuccessAction,
  GetGamesSuccessAction,
  GetLastPlayedGamesSuccessAction,
} from './actions';
import {
  BffGamesCategory,
  BffGamesJackpotsResponse,
  BffGamesResponse,
  BffGamesLastPlayedResponse,
  BffFavouriteGamesResponse,
} from '@lucky7ventures/bff-types';
import { defineState } from 'redux-localstore';

export interface GamesStateModel {
  games: BffGamesResponse['games'];
  categories: Partial<Record<BffGamesCategory, number[]>>;
  providers: Record<string, { name: string; games: number[] }>;
  loading: boolean;
  error: boolean;
  success: boolean;
  lastPlayedIds: BffGamesLastPlayedResponse;
  jackpots: BffGamesJackpotsResponse;
  favouriteGamesIds: BffFavouriteGamesResponse;
}

const defaultState: GamesStateModel = {
  games: {},
  categories: {},
  providers: {},
  loading: false,
  error: false,
  success: false,
  lastPlayedIds: [],
  jackpots: {},
  favouriteGamesIds: [],
};

const initialState = defineState(defaultState)('games');

const getGames = (state: GamesStateModel): GamesStateModel => ({
  ...state,
  loading: true,
  error: false,
});

const getGamesSuccess = (
  state: GamesStateModel,
  action: GetGamesSuccessAction,
): GamesStateModel => ({
  ...state,
  games: action.games,
  providers: action.providers,
  categories: action.categories,
  loading: false,
  error: false,
  success: true,
});

const getFavouriteGamesSuccess = (
  state: GamesStateModel,
  action: GetFavouriteGamesSuccessAction,
): GamesStateModel => ({
  ...state,
  favouriteGamesIds: action.favouriteGamesIds,
  error: false,
});

const getGamesError = (state: GamesStateModel) => ({
  ...state,
  loading: false,
  error: true,
  success: false,
});

const getLastPlayedGamesSuccess = (
  state: GamesStateModel,
  action: GetLastPlayedGamesSuccessAction,
): GamesStateModel => ({
  ...state,
  lastPlayedIds: action.lastPlayedIds,
});

const clearLastPlayedGames = (state: GamesStateModel): GamesStateModel => ({
  ...state,
  lastPlayedIds: [],
});

const clearFavouriteGames = (state: GamesStateModel): GamesStateModel => ({
  ...state,
  favouriteGamesIds: [],
});

export const gamesReducers = (state = initialState, action: Actions): GamesStateModel => {
  switch (action.type) {
    case GamesActionsTypes.Get:
      return getGames(state);
    case GamesActionsTypes.GetSuccess:
      return getGamesSuccess(state, action);
    case GamesActionsTypes.GetFavouriteGamesSuccess:
      return getFavouriteGamesSuccess(state, action);
    case GamesActionsTypes.GetError:
      return getGamesError(state);
    case GamesActionsTypes.GetLastPlayedGamesSuccess:
      return getLastPlayedGamesSuccess(state, action);
    case GamesActionsTypes.ClearLastPlayedGames:
      return clearLastPlayedGames(state);
    case GamesActionsTypes.ClearFavouriteGames:
      return clearFavouriteGames(state);
    case GamesActionsTypes.GetGamesJackpotsSuccess:
      return {
        ...state,
        jackpots: action.data,
      };
    default:
      return state;
  }
};
